import { createFileRoute, useNavigate } from '@tanstack/react-router';
// Route options read the light search module; the page is code-split with the component.
import { SearchPage } from '@/features/search/search-page';
import { SearchPageSearchSchema } from '@/features/search/search';

/** The full results of the global search: the query and the kind of results are in the address. */
export const Route = createFileRoute('/_auth/o/$orgId/search')({
  validateSearch: (search) => SearchPageSearchSchema.parse(search),
  component: SearchRoute,
});

function SearchRoute() {
  const { orgId } = Route.useParams();
  const { q, scope } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <SearchPage
      orgId={orgId}
      q={q}
      scope={scope}
      onQueryChange={(next) => {
        void navigate({
          search: (previous) => ({ ...previous, q: next === '' ? undefined : next }),
          replace: true,
        });
      }}
      onScopeChange={(next) => {
        void navigate({
          search: (previous) => ({ ...previous, scope: next === 'all' ? undefined : next }),
          replace: true,
        });
      }}
    />
  );
}
